/*
* created by Fabio Fusco
*
* UTILIZO PIPE -- FilterPipe --
*
* si se pasa el input como id buscara en la tabla  solo en la columna indicada,
*
* si en cambio no se pasa nada como id, buscara en la tabla en todas las columnas
* */

import {Component, OnInit, Input, Output, EventEmitter} from '@angular/core';

@Component({
    selector: 'app-search-text',
    template:`<div class="input-group">
        <input id={{id}} [(ngModel)]="text" (keyup)="filter(text,id)" placeholder="{{(id)?id:'Search by All'}}" type="text" class="form-control"/>
        <span class="input-group-addon">
        <i class="fa fa-search"></i>
    </span>
    </div>`,
    styleUrls: ['./search-text.component.scss']
})
export class SearchTextComponent implements OnInit {

    @Input() id:any;

    @Output() search= new EventEmitter();

  constructor() { }

  ngOnInit() {}

  filter(value,type=null){
      let out_value={by:type,text:value};
     this.search.emit(out_value);
  }

}



// WEBPACK FOOTER //
// /var/www/backend/src/app/shared/components/search-text/search-text.component.ts